module.exports = "/pages/business/foodslabo/fv_model.png";